import * as React from 'react';
import {
    Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { AuthenticationContext } from './context/AuthenticationContext';
import CartMenuIcon from './CartMenuIcon';
import { withRouter } from 'react-router-dom';
import CheckoutPartnerHeaderSteps from '../pages/Checkout/CheckoutPartnerHeaderSteps';

class NavMenu extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {

        const isCheckout = window.location.pathname.indexOf('/checkout') === 0;

        return (
            <header className="bg-white">
                <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" light>
                    <Container fluid={isCheckout}>
                        <NavbarBrand tag={Link} to="/"><img src="/images/iNet_Logo.svg" alt="iNet"/></NavbarBrand>
                        {!isCheckout && <NavbarToggler onClick={this.toggle} className="mr-2" />}
                        {!isCheckout && <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav flex-grow">
                                <AuthenticationContext.Consumer>
                                    {(authCtx) => <React.Fragment>
                                        {
                                            authCtx.currentUser &&
                                            <>
                                                <NavItem>
                                                    <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink tag={Link} className="text-dark" to="/order-search">My Orders</NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink tag={Link} className="text-dark" to="/cart-search">Search Cart</NavLink>
                                                </NavItem>
                                                {authCtx.currentUser.IsAdmin &&
                                                    <>
                                                        <NavItem>
                                                            <NavLink tag={Link} className="text-dark" to="/admin/product-builder">Product Builder</NavLink>
                                                        </NavItem>
                                                        <NavItem>
                                                            <NavLink tag={Link} className="text-dark" to="/admin/product-attributes">Product Attributes</NavLink>
                                                        </NavItem>
                                                        <NavItem>
                                                            <NavLink tag={Link} className="text-dark" to="/admin/inventory-export">Inventory Export</NavLink>
                                                        </NavItem>
                                                    </>
                                                }
                                                {(authCtx.currentUser.IsAdmin || authCtx.currentUser.IsLogViewer) &&
                                                    <>
                                                        <NavItem>
                                                            <NavLink tag={Link} className="text-dark" to="/admin/log">Log</NavLink>
                                                        </NavItem>
                                                    </>
                                                }
                                                
                                                <NavItem className="nav-item-cart">
                                                    <NavLink tag={Link} className="text-dark" onClick={() => { window.location.href="/cart" }}><CartMenuIcon /></NavLink>
                                                </NavItem>
                                                <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret>
                                                    <span className="rounded-circle">{authCtx.currentUser.Initials}</span>
                                                    {authCtx.currentUser.UserName}
                                                </DropdownToggle>
                                                <DropdownMenu right>
                                                    <DropdownItem>
                                                        <NavLink className="text-dark"
                                                            onClick={() => authCtx.authorizationActions.logout()}>Logout</NavLink>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </>
                                        }
                                        {
                                            !authCtx.currentUser &&
                                            <NavItem>
                                                <NavLink tag={Link} className="text-dark" to="/login">Login</NavLink>
                                            </NavItem>
                                        }
                                    </React.Fragment>}
                                </AuthenticationContext.Consumer>        
                            </ul>
                        </Collapse>}
                        {isCheckout && <CheckoutPartnerHeaderSteps />}
                    </Container>
                </Navbar>
            </header>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}


export default withRouter(NavMenu as any);